"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvg = _interopRequireWildcard(require("../utilities/createSvg"));
var _DepartureArrowIcon = _interopRequireDefault(require("./DepartureArrowIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * **❗️ DEPRECATED**
 * @deprecated
 */
var _default = exports.default = (0, _createSvg.default)({
  name: 'DepartureArrowIcon',
  inlineSvg: _DepartureArrowIcon.default,
  width: 36,
  height: 12,
  path: `${_createSvg.externalBasePath}/DepartureArrowIcon/DepartureArrowIcon.svg#root`
});